/* ga-ids.js - carry the buyer's GA4 client id + session id onto the ORDER (TG-208).
 *
 * WHY: a purchase that never reaches the thank-you page (Razorpay offsite, #1004 / #1006) is lost to GA4.
 * ga4_purchase_backfill.py re-sends those orders with the Measurement Protocol, and a server-sent purchase only
 * attributes to the right session/campaign if it carries the SAME client_id + session_id the browser used.
 * Nothing else in the order holds them, so this script puts them there:
 *
 *   1. hidden line-item properties  properties[_ga_cid] / properties[_ga_sid]  in every /cart/add form
 *      -> survives BOTH add-to-cart AND "Buy it now" (the dynamic checkout button submits the form's properties)
 *   2. cart attributes  _ga_cid / _ga_sid  when the cart already has items
 *      -> covers checkouts started from the cart page
 *
 * Underscore-prefixed keys are hidden from the customer by Shopify. Never throws: a failure here must not
 * touch add-to-cart or checkout, so every step is wrapped and silent.
 */
(function () {
  "use strict";
  var MID = "LMDYRPX9S6";                               // G-LMDYRPX9S6

  function cookie(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : "";
  }

  function ids() {
    var cid = "", sid = "";
    var ga = cookie("_ga");                             // GA1.1.<rand>.<ts>
    var p = ga.split(".");
    if (p.length >= 4) cid = p[p.length - 2] + "." + p[p.length - 1];
    var gs = cookie("_ga_" + MID);                      // GS1.1.<sid>.<n>...  or  GS2.1.s<sid>$o..$g..$t..
    var m = gs.match(/^GS2\.\d+\.s(\d+)/);
    if (m) sid = m[1];
    else {
      var q = gs.split(".");
      if (q.length >= 3 && /^\d+$/.test(q[2])) sid = q[2];
    }
    return { cid: cid, sid: sid };
  }

  function stamp(form) {
    try {
      var v = ids();
      if (!v.cid) return;
      [["_ga_cid", v.cid], ["_ga_sid", v.sid]].forEach(function (kv) {
        if (!kv[1]) return;
        var name = "properties[" + kv[0] + "]";
        var el = form.querySelector('input[name="' + name + '"]');
        if (!el) {
          el = document.createElement("input");
          el.type = "hidden";
          el.name = name;
          form.appendChild(el);
        }
        el.value = kv[1];
      });
    } catch (e) {}
  }

  function stampAll() {
    try {
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) stamp(forms[i]);
    } catch (e) {}
  }

  // Refresh on submit too: the GA cookies may not exist yet at DOMContentLoaded on a first visit.
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf("/cart/add") !== -1) stamp(f);
  }, true);
  // Buy-it-now is a click on the dynamic checkout button, not a form submit - stamp before it reads the form.
  document.addEventListener("pointerdown", function (e) {
    var t = e.target;
    var f = t && t.closest && t.closest('form[action*="/cart/add"]');
    if (f) stamp(f);
  }, true);

  function syncCart() {
    try {
      var v = ids();
      if (!v.cid || !window.fetch) return;
      fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (c) {
        if (!c || !c.item_count) return;
        var a = c.attributes || {};
        if (a._ga_cid === v.cid && a._ga_sid === v.sid) return;
        fetch("/cart/update.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: { _ga_cid: v.cid, _ga_sid: v.sid } })
        }).catch(function () {});
      }).catch(function () {});
    } catch (e) {}
  }

  function start() {
    stampAll();
    setTimeout(stampAll, 2500);                         // after gtag has had time to set the cookies
    setTimeout(syncCart, 3000);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
